import { Box, Modal } from '@mui/material';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { InputSelect } from 'app/components/elements/InputSelect';
import { InputText } from 'app/components/elements/InputText';
import React, { ChangeEvent } from 'react';

export const inspectionOptions = [
  { value: 'REPORT_ISSUE', label: 'Report Issue' },
  { value: 'ASSET', label: 'Asset' },
  { value: 'ADDITIONAL_STRUCTURE', label: 'Additional Structure' },
  { value: 'ROOM_LEVEL_ISSUE', label: 'Location Level Issue' },
  { value: 'ROOM', label: 'Room' },
  { value: 'ASSET_TYPE', label: 'Asset Type' },
  { value: 'ASSET_MODEL', label: 'Asset Model' }
];

const ModalNewDropdown = ({
  open,
  onClose,
  onSubmit,
  clientOptions
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (val: { type: string; name: string; clientIds?: number[] }) => Promise<void>;
  clientOptions?: { value: string; label: string }[];
}) => {
  const [dropdownName, setDropdownName] = React.useState('');
  const [optionName, setOptionName] = React.useState('');
  const [selectedClientIds, setSelectedClientIds] = React.useState<string[]>([]);

  const onSave = async () => {
    await onSubmit({
      type: optionName,
      name: dropdownName,
      clientIds: selectedClientIds.length ? selectedClientIds.map(Number) : undefined
    });
    setOptionName('');
    setDropdownName('');
    setSelectedClientIds([]);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          maxWidth: 400,
          margin: 'auto',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Box
          sx={{
            padding: 2,
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            borderRadius: '10px',
            overflow: 'hidden',
            flex: 1,
            paddingBottom: 2
          }}>
          <h2 style={{ margin: 0 }}>Create New Dropdown</h2>
          <InputSelect
            options={inspectionOptions}
            value={optionName}
            title="Select Type"
            placeholder="Select a type"
            onChange={(e) => setOptionName(e.target.value as string)}
          />
          <InputText
            title={'Dropdown Name'}
            placeholder={'Enter dropdown name'}
            inputProps={{
              value: dropdownName,
              onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                setDropdownName(e.target.value)
            }}
          />
          {clientOptions && clientOptions.length > 0 && (
            <InputSelect
              multiple
              options={clientOptions}
              value={selectedClientIds}
              title="Clients"
              placeholder="Select clients"
              onChange={(e) => setSelectedClientIds(e.target.value as unknown as string[])}
            />
          )}

          <ButtonCustom
            label="Save"
            disabled={!dropdownName || !optionName || !selectedClientIds.length}
            onClick={onSave}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalNewDropdown;
